export interface ICenterContactPosition {
    message: string
}